import classNames from 'classnames';
import { IconClose } from '@koleso-icons';
import Image, { StaticImageData } from 'next/image';
import { Button } from '@app/shared';
import { ReactNode, useEffect } from 'react';

import styles from './ModalWindow.module.scss';

interface PropsModal {
  value?: string;
  text?: string;
  info?: string;
  image?: StaticImageData;
  className?: string;
  buttonTextOne?: string;
  buttonTextTwo?: string;
  idTextBtn?: string;
  idTextBtnTwo?: string;
  btnAction?: () => void;
  setActive?: (param: boolean) => void;
  resetValue?: () => void;
  active?: boolean;
  children?: ReactNode;
  showSuccess?: boolean;
}

export const ModalWindow = ({
  value,
  text,
  info,
  image,
  buttonTextOne,
  buttonTextTwo,
  btnAction,
  setActive,
  active,
  className,
  resetValue,
  children,
  showSuccess,
  idTextBtn,
  idTextBtnTwo,
}: PropsModal) => {
  const handlerOpenModal = () => {
    resetValue && resetValue();
    setActive(!active);
  };

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        handlerOpenModal();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  return (
    <div className={classNames(styles.Container, className)} onClick={handlerOpenModal}>
      {showSuccess ? (
        <ModalWindow.NotificateSuccess handlerOpenModal={handlerOpenModal} />
      ) : (
        <div className={styles.WrapperModal} onClick={e => e.stopPropagation()}>
          <span>{value}</span>
          <span className={styles.OpenModal}>
            <IconClose width={24} height={24} onClick={handlerOpenModal} />
          </span>
          {image && <Image src={image} alt="service" />}
          <p>{text}</p>
          {info && <span className={styles.Info}>{info}</span>}
          {children}
          <div className={styles.ButtonGroup}>
            {buttonTextOne && (
              <Button onClick={handlerOpenModal} className={styles.BtnCancellation} id={idTextBtn}>
                {buttonTextOne}
              </Button>
            )}
            {buttonTextTwo && (
              <Button onClick={btnAction} className={styles.BtnRemove} id={idTextBtnTwo}>
                {buttonTextTwo}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

ModalWindow.NotificateSuccess = function NotificateSuccess({ handlerOpenModal }) {
  return (
    <div className={styles.WrapperNotificate} onClick={e => e.stopPropagation()}>
      <div className={styles.Info}>
        <div>Спасибо!</div>
        <div>Мы передали информацию менеджеру.</div>
      </div>
      <IconClose width={24} height={24} onClick={handlerOpenModal} />
    </div>
  );
};
